import React from 'react'
import {PageTitle} from '../../../_metronic/layout/core'
import {Navigate, Route, Routes} from 'react-router-dom'
import TypesActionsListPage from './TypesActionsListPage'
import TypesActionsAddPage from './TypesActionsAddPage'
import TypesActionsEditPage from './TypesActionsEditPage'

const TypesActionsWrapper = () => {
  return (
    <>
      <Routes>
        <Route
          path='/liste'
          element={
            <>
              <PageTitle breadcrumbs={[
                {
                  title: 'Paramètres',
                  path: '#',
                  isSeparator: false,
                  isActive: true,
                }
              ]}>Types actions</PageTitle>
              <TypesActionsListPage />
            </>
          }
        />
        <Route
          path='/ajouter'
          element={
            <>
              <PageTitle breadcrumbs={[
                { title: 'Paramètres', path: '#', isSeparator: false, isActive: false },
                { title: 'Types actions', path: '/types-actions', isSeparator: false, isActive: true },
              ]}>Création</PageTitle>
              <TypesActionsAddPage />
            </>
          }
        />
        <Route
          path='/:typeId/modifier'
          element={
            <>
              <PageTitle breadcrumbs={[
                { title: 'Paramètres', path: '#', isSeparator: false, isActive: false },
                { title: 'Types actions', path: '/types-actions', isSeparator: false, isActive: true },
              ]}>Modification</PageTitle>
              <TypesActionsEditPage />
            </>
          }
        />
        <Route index element={<Navigate to='liste' />} />
      </Routes>
    </>
  )
}

export default TypesActionsWrapper
